<template>
  <div class="mb-4 rounded-lg bg-scheme-main-bis p-4">
    <h3 class="mb-2 font-semibold">Campaign Statistics</h3>

    <!-- Loading State -->
    <div v-if="isLoading && !campaignStats" class="py-4 text-center">
      <span class="">Loading campaign statistics...</span>
    </div>

    <!-- Stats Display -->
    <div v-else-if="campaignStats" class="grid grid-cols-2 gap-4 text-sm">
      <div class="col-span-2">
        <span class="font-medium">Campaign Key:</span>
        <span class="font-mono ml-2">{{ campaignStats.campaignKey }}</span>
      </div>
      <div>
        <span class="font-medium">Total Quota:</span>
        <span class="ml-2 font-bold">{{ campaignStats.quota }}</span>
      </div>
      <div>
        <span class="font-medium">Already Sent:</span>
        <span class="ml-2 font-bold">{{ campaignStats.sendPostcards }}</span>
      </div>
      <div class="col-span-2">
        <span class="font-medium">Available to Send:</span>
        <span class="ml-2 font-bold">{{
          campaignStats.freeToSendPostcards
        }}</span>
      </div>
    </div>

    <!-- Error State -->
    <div v-else class="py-4 text-center">
      <span class="text-danger">Failed to load campaign statistics</span>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ campaignKey: string }>()
const { campaignStats, fetchCampaignStats, isLoading } = useCampaignData()

onMounted(async () => {
  if (props.campaignKey) {
    await fetchCampaignStats(props.campaignKey)
  }
})
</script>

<style scoped></style>
